var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',_vm._b({attrs:{"headers":_vm.headers,"items":_vm.list,"hide-default-footer":"","disable-pagination":""},scopedSlots:_vm._u([{key:"item.log_type",fn:function(ref){
var value = ref.value;
var item = ref.item;
return [_c('div',{class:_vm.getClassForName(item),domProps:{"textContent":_vm._s(_vm.getName(value))}})]}},{key:"item.history",fn:function(ref){
var item = ref.item;
return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.getHistory(item))}})]}},{key:"item.status",fn:function(ref){
var value = ref.value;
return [_c('BTooltipButton',{attrs:{"icon":_vm.getIcon(value),"tooltip":_vm.getTooltip(value),"top":""}})]}}])},'v-data-table',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }